import at from '../actionTypes'
import createReducer from './utilities/createReducer'
import { getLocalisedMessage } from '../../utilities/Errors/index'
import that from '../../utilities/translationHelper'
import showAppMessage from './utilities/showAppMessage'

const genericUserNotFoundError = that.context.translate('An error occurred trying to fetch the user')

export default createReducer({}, {
	/* User profile being viewed */
	[at.userProfilePublic.fetch.BEGIN]: state => ({
		...state,
		userProfilePublic: undefined
	}),
	[at.userProfilePublic.fetch.SUCCESS]: (state, action) => {
		const userProfilePublic = action.payload.userProfilePublic
		return {
			...state,
			userProfilePublic
		}
	},
	[at.userProfilePublic.fetch.FAIL]: (state, action) => {
		const newState = {
			...state,
			userPublicNameNotFound: true,
			...showAppMessage(getLocalisedMessage(action.payload.error, genericUserNotFoundError))
		}
		delete newState.userProfilePublic
		return newState
	}
})



// WEBPACK FOOTER //
// ./src/redux/reducers/userProfilePublicReducer.js